import { render } from "./footer.vue?vue&type=template&id=769d4944&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=769d4944&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-769d4944"

export default script